import { AxiosPromise, AxiosStatic } from "axios";
import { TNotification } from "../types";

const getNotifications =
  (serverURL: string, appAxios: AxiosStatic) =>
  async (): AxiosPromise<TNotification[]> =>
    await appAxios.get(`${serverURL}/notifications`, {
      withCredentials: true,
    });

export default getNotifications;
